// extracted by mini-css-extract-plugin
module.exports = {"unreadMessagesIndicator":"UnreadMessagesIndicator_unreadMessagesIndicator__xkbZZ"};